import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/newPhone/default.svg'
import _imports_1 from '@/assets/earth.svg'


const _withScopeId = n => (_pushScopeId("data-v-82e8c256"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "mod_wrap mod_set_wrap",
  ref: "mediaRef"
}
const _hoisted_2 = { class: "mod_c_title watch_title" }
const _hoisted_3 = { class: "community" }
const _hoisted_4 = { class: "picture" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_6 = { class: "community_aside" }
const _hoisted_7 = { class: "community_aside_son" }
const _hoisted_8 = { class: "community_foste" }
const _hoisted_9 = { class: "community_second" }
const _hoisted_10 = { class: "community_second_two" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "community_second_son" }
const _hoisted_13 = { class: "community_second_one" }
const _hoisted_14 = { class: "container" }
const _hoisted_15 = { class: "container_tab" }
const _hoisted_16 = { class: "container_tab_table" }
const _hoisted_17 = { class: "table_ul" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cetp_earth" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "more" }, "显示位置 :", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "more" }, "全屏", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "more" }, "顶部", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "more" }, "中文文字 :", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "more" }, "英文文字 :", -1))
const _hoisted_24 = { class: "table_begin" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "more" }, "开播时间 :", -1))
const _hoisted_26 = ["src"]
const _hoisted_27 = { class: "keep_board" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "more" }, "距离直播 :", -1))
const _hoisted_29 = { class: "community_foste" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Crumb = _resolveComponent("Crumb")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_statistic_countdown = _resolveComponent("a-statistic-countdown")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Crumb, { showliveInfo: "" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createTextVNode(" 开播倒计时 "),
        _createVNode(_component_a_switch, {
          class: "btns_txt",
          onChange: _ctx.stay,
          checked: _ctx.opened,
          "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.opened) = $event))
        }, null, 8, ["onChange", "checked"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _withDirectives(_createElementVNode("div", _hoisted_6, [
            _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.languageType == 1 ? _ctx.words : _ctx.writing), 1),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_a_row, { gutter: 16 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_statistic_countdown, {
                        class: "community_statistic",
                        value: _ctx.deadline,
                        format: _ctx.langTypeCode
                      }, null, 8, ["value", "format"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ], 512), [
            [_vShow, _ctx.open == '1']
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("img", { src: _ctx.chart }, null, 8, _hoisted_11)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.languageType == 1 ? _ctx.words : _ctx.writing), 1),
              _createElementVNode("div", null, [
                _createVNode(_component_a_row, { gutter: 16 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_statistic_countdown, {
                          value: _ctx.deadline,
                          class: "community_second_col",
                          format: _ctx.langTypeCode
                        }, null, 8, ["value", "format"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ])
          ], 512), [
            [_vShow, _ctx.open == '0']
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("ul", _hoisted_17, [
                _createElementVNode("li", null, [
                  _createElementVNode("div", {
                    class: "cetp_input_wrap_input",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => {
                    {
                      _ctx.languageType = _ctx.languageType === 1 ? 2 : 1;
                    }
                  })
                  }, [
                    _hoisted_18,
                    _createElementVNode("div", {
                      class: "cept_china",
                      style: _normalizeStyle({ color: _ctx.languageType == 2 ? '#ccc' : '' })
                    }, "中", 4),
                    _createTextVNode(" / "),
                    _createElementVNode("div", {
                      class: "cept_eng",
                      style: _normalizeStyle({ color: _ctx.languageType == 1 ? '#ccc' : '' })
                    }, "ENG", 4)
                  ])
                ]),
                _createElementVNode("li", null, [
                  _hoisted_19,
                  _createVNode(_component_a_radio_group, {
                    name: "radioGroup",
                    value: _ctx.open,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.open) = $event)),
                    class: "table_radio"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_radio, {
                        value: "1",
                        defaultValue: ""
                      }, {
                        default: _withCtx(() => [
                          _hoisted_20
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_radio, { value: "0" }, {
                        default: _withCtx(() => [
                          _hoisted_21
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _withDirectives(_createElementVNode("li", null, [
                  _hoisted_22,
                  _createVNode(_component_a_input, {
                    type: "text",
                    class: "table_input",
                    value: _ctx.words,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.words) = $event)),
                    placeholder: "请输入内容最长10个字符",
                    maxlength: 10
                  }, null, 8, ["value"])
                ], 512), [
                  [_vShow, _ctx.languageType ? _ctx.languageType == 1 : '']
                ]),
                _withDirectives(_createElementVNode("li", null, [
                  _hoisted_23,
                  _createVNode(_component_a_input, {
                    type: "text",
                    class: "table_input",
                    value: _ctx.writing,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.writing) = $event)),
                    placeholder: "请输入内容最长20个字符",
                    maxlength: 20
                  }, null, 8, ["value"])
                ], 512), [
                  [_vShow, _ctx.languageType ? _ctx.languageType == 2 : '']
                ]),
                _createElementVNode("li", _hoisted_24, [
                  _hoisted_25,
                  _createVNode(_component_a_space, {
                    direction: "vertical",
                    class: "table_space"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_date_picker, {
                        "show-time": "",
                        placeholder: "选择时间",
                        onChange: _ctx.onChange,
                        class: "cache_top_picker",
                        value: _ctx.time,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.time) = $event))
                      }, {
                        suffixIcon: _withCtx(() => [
                          _createElementVNode("img", {
                            class: "range_picker_icon",
                            src: _ctx.RangePickerIcon
                          }, null, 8, _hoisted_26)
                        ]),
                        _: 1
                      }, 8, ["onChange", "value"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_27, [
                  _hoisted_28,
                  _createElementVNode("div", _hoisted_29, [
                    _createVNode(_component_a_row, { gutter: 16 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 1524 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_statistic_countdown, {
                              class: "community_statistic",
                              value: _ctx.deadline,
                              format: _ctx.langTypeCode,
                              getContainer: () => _ctx.mediaRef
                            }, null, 8, ["value", "format", "getContainer"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_a_button, {
                    class: "table_button",
                    type: "primary",
                    onClick: _ctx.stay,
                    disabled: _ctx.disabled
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("保存")
                    ]),
                    _: 1
                  }, 8, ["onClick", "disabled"])
                ])
              ])
            ])
          ])
        ])
      ])
    ], 512)
  ], 64))
}